import { Link } from "react-router-dom";
import { useTokens } from "@/design-system/hooks/useTokens";
import { useNavigationService } from "@/application/services/navigationService";

interface NavLinksProps {
  isMobile?: boolean;
  onItemClick?: () => void;
  showMainNav?: boolean;
}

/**
 * 導航連結組件
 * 顯示應用程式的導航連結，可以顯示主導航或子導航
 */
export function NavLinks({
  isMobile = false,
  onItemClick,
  showMainNav = false,
}: NavLinksProps) {
  const tokens = useTokens();
  const { getFilteredNavItems, getSubNavItems, isActive, getCurrentMainNav } =
    useNavigationService();

  // 根據 showMainNav 屬性決定顯示主導航或子導航
  const navItems = showMainNav
    ? getFilteredNavItems().filter((item) => item.isMainNav)
    : getSubNavItems();

  // 獲取當前主導航（用於在子導航中顯示標題）
  const currentMainNav = getCurrentMainNav();

  // 如果是子導航且沒有項目，不顯示任何內容
  if (!showMainNav && navItems.length === 0) {
    return null;
  }

  // 如果是子導航，顯示當前主導航的標題和子項目
  if (!showMainNav && currentMainNav) {
    return (
      <div className="flex items-center space-x-4">
        {/* 當前主導航標題 */}
        {/* <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
          {currentMainNav.label}:
        </span> */}

        {/* 子導航項目 */}
        <div className="flex space-x-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`${isMobile ? "block" : "inline-flex items-center"} 
                ${isMobile ? "px-3 py-2 text-base" : "px-3 py-2 text-sm"} 
                font-medium ${isMobile ? "" : "rounded-md"} 
                ${
                  isActive(item.path)
                    ? "text-primary-700 dark:text-primary-400 bg-primary-50 dark:bg-gray-700"
                    : "text-gray-700 dark:text-gray-300 hover:text-primary-500 dark:hover:text-primary-400"
                }`}
              style={{
                color: isActive(item.path)
                  ? tokens.colors.primary.dark
                  : tokens.colors.text.primary,
                backgroundColor: isActive(item.path)
                  ? tokens.colors.primary.light + "20"
                  : "transparent",
              }}
              onClick={onItemClick}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    );
  }

  // 顯示主導航項目
  return (
    <>
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`${isMobile ? "block" : "inline-flex items-center"} 
            ${isMobile ? "px-3 py-2 text-base" : "px-3 py-2 text-sm"} 
            font-medium ${isMobile ? "" : "rounded-md"} 
            ${
              isActive(item.path)
                ? "text-primary-700 dark:text-primary-400 bg-primary-50 dark:bg-gray-700"
                : "text-gray-700 dark:text-gray-300 hover:text-primary-500 dark:hover:text-primary-400"
            }`}
          style={{
            color: isActive(item.path)
              ? tokens.colors.primary.dark
              : tokens.colors.text.primary,
            backgroundColor: isActive(item.path)
              ? tokens.colors.primary.light + "20"
              : "transparent",
          }}
          onClick={onItemClick}
        >
          {item.label}
        </Link>
      ))}
    </>
  );
}
